<template>
  <div>
    <div
      v-for="i in new Array(20)"
      :key="i"
      class="d-flex justify-content-between"
    >
      <div v-for="(field, index) in fields" :key="index" class="table-row animated-text-line my-3" :style="{ width:field.width - 1 + '%' }" />
    </div>
  </div>
</template>
<script>
export default {
  name: "TableLoader",
  props:{
    fields:{
      type: Array
    }
  }
}
</script>
<style lang="scss" scoped>
  .animated-text-line {
    height: 15px;
  }
</style>